import { useEffect, useMemo, useState } from 'react';
import { api } from '../services/api';

export default function WelcomeOverlay({ onFinish }) {
  const [phase, setPhase] = useState('loading');
  const [companyName, setCompanyName] = useState('');

  useEffect(() => {
    let isMounted = true;
    let nextPhaseTimeout;
    const fallbackTimeout = setTimeout(() => {
      if (isMounted) {
        setPhase('message');
      }
    }, 3000);

    const fetchCompany = async () => {
      try {
        const dados = await api.getEmpresaConfig();
        if (!isMounted) return;
        const rawName = dados?.nome_fantasia || dados?.razao_social || '';
        setCompanyName(rawName);
      } catch (error) {
        if (!isMounted) return;
        setCompanyName('');
      } finally {
        if (!isMounted) return;
        nextPhaseTimeout = setTimeout(() => {
          if (isMounted) {
            setPhase('message');
          }
        }, 600);
      }
    };

    fetchCompany();

    return () => {
      isMounted = false;
      if (nextPhaseTimeout) {
        clearTimeout(nextPhaseTimeout);
      }
      clearTimeout(fallbackTimeout);
    };
  }, []);

  useEffect(() => {
    if (phase !== 'message') {
      return undefined;
    }

    const timeout = setTimeout(() => {
      if (typeof onFinish === 'function') {
        onFinish();
      }
    }, 1500);

    return () => clearTimeout(timeout);
  }, [phase, onFinish]);

  const welcomeMessage = useMemo(() => {
    if (!companyName) {
      return 'Bem-vindo';
    }

    const firstWord = companyName.trim().split(/\s+/)[0] || '';
    if (!firstWord) {
      return 'Bem-vindo';
    }

    return `Bem-vindo, ${firstWord.toUpperCase()}`;
  }, [companyName]);

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center bg-gradient-to-br from-primary-900 via-primary-700 to-primary-500 text-white">
      <div className="text-center space-y-6">
        {phase === 'loading' ? (
          <div className="flex flex-col items-center gap-6 animate-fade-in">
            <div className="relative w-20 h-20">
              <div className="absolute inset-0 rounded-full border-4 border-white/30" />
              <div className="absolute inset-0 rounded-full border-4 border-transparent border-t-white animate-spin" />
            </div>
            <p className="text-lg font-medium text-white/80">Preparando seu ambiente...</p>
          </div>
        ) : (
          <div className="space-y-4 animate-fade-in">
            <h1 className="text-4xl sm:text-5xl font-bold tracking-tight drop-shadow-lg">{welcomeMessage}</h1>
            <p className="text-base sm:text-lg text-white/80">Desejamos uma excelente experiência no ControleMax.</p>
          </div>
        )}
      </div>
    </div>
  );
}
